<template>
    <div class="section">
        <div class="section__inner">
            <div class="section__body">
                <div class="container">
                    <div class="row nowrap stretch section__row">
                        <NumbersCard v-for="(item, i) in items" :key="i" v-bind="item"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import NumbersCard from './NumbersCard.vue'

export default {
    name: 'NumbersSection',
    components: {
        NumbersCard,
    },
    props: {
        items: {
            type: Array,
            default: [],
        }
    },
    setup: (props, ctx) => {

        return {}
    },
}
</script>

<style scoped>
.section__row {
    overflow: auto;
}
</style>